import Editable from "../../Editable";
import InfoField from "../../InfoField";
import { useQuery } from "@apollo/client";
import { SPORT, UPDATE_SPORT } from "../../../api/sports";
import SPORTS from "../../../api/queries/sports";
import moment from "moment";
import Form from "../../Form";
import { FaTimes } from "react-icons/fa";
import StatTypeGroupList from "./StatTypeGroupList";
import StatTypeList from "./StatTypeList";

function SportStatTypes({ sport }) {
  return (
    <div className="page">
      <div className="section">
        <StatTypeGroupList id={sport.id} />
      </div>
      <div className="section">
        <StatTypeList id={sport.id} />
      </div>
    </div>
  );
}

export default SportStatTypes;
